export enum EventCustomRegFieldUiControlType {
  Checkbox,
  DropdownList,
  NumberInputDecimal,
  NumberInputNoDecimal,
  TextboxSingleLine,
  TextboxMultiLine,
}
